import { emptyStringPropsToNull, formatSSNNumber } from '@surglogs/util'

import { useHandler } from '@surglogs-app/hooks'
import { useAccessManagementAccountPutMutation } from '@surglogs-app/network'
import { useToast } from '@surglogs-app/ui.toast'

export const useUserEditSubmitHandler = ({
  onSuccess,
}: {
  onSuccess: () => void
}) => {
  const { showErrorToast } = useToast()
  const mutation = useAccessManagementAccountPutMutation({})
  const submit = useHandler(async (data: any) => {
    try {
      await mutation.mutateAsync({
        data: {
          email: data.email,
          first_name: data.first_name,
          last_name: data.last_name,
          middle_name: data.middle_name || null,
          other_names: data.other_names || null,
          dob: data.dob || null,
          daytime_number: data.daytime_number || null,
          cell_number: data.cell_number || null,
          ssn: data.ssn ? formatSSNNumber(data.ssn) : null,
          npi: data.npi || null,
          address: emptyStringPropsToNull(data.address),
          title: data.title,
        },
      })
      onSuccess()
    } catch (error) {
      showErrorToast({ error })
    }
  })

  return [submit, mutation] as const
}
